import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Typography,
  StatusIndicator,
  DateCTA,
  NewDateFIlterModal as DateFilterModal,
  Loader,
  MultiSelect,
} from "components";
import {
  setRatioDates,
  getAgentAggregatorRatio,
  setRatioRegions,
} from "redux/actions/dashboard/onboardingDashboardActions";

const AgentToAggregatorRatio = () => {
  const [openDateModal, setOpenDateModal] = useState(false);
  const [selectedRegions, setSelectedRegions] = useState([]);
  const { regions } = useSelector((state) => state.regions);

  const { agentAggregatorRatio } = useSelector(
    (state) => state.onboardingReducer
  );

  const { data, loading, dates, regionCode } = agentAggregatorRatio || {};

  const { totalAgent, totalAggregator, ratio } = data || {};

  const handleModalClose = () => setOpenDateModal(false);

  const getAgentsData = () => {
    getAgentAggregatorRatio(dates, regionCode);
    handleModalClose();
  };

  useEffect(() => {
    getAgentsData();
    //eslint-disable-next-line
  }, []);

  const getRegionOptions = () =>
    regions?.map((region) => ({
      label: region.name,
      value: region.regionCode,
    }));

  const handleRegionsChange = (val) => {
    setSelectedRegions(val);
    val.length
      ? setRatioRegions(val.map((i) => i.value))
      : setRatioRegions(null);
  };

  const ratios = ratio?.split(":") || [];

  const aggregatorPercentage = Math.round(
    (Number(ratios[1]) / (Number(ratios[0]) + Number(ratios[1]))) * 100
  );

  const childToRender = (
    <div className="dashboard-card status-indicator-child d-flex justify-content-center align-items-center">
      <Typography variant="subtitle3">
        {ratios[0]} : {ratios[1]}
      </Typography>
    </div>
  );

  return (
    <div
      className="dashboard-card pb-3"
      style={{ position: "relative", minHeight: "26rem" }}
    >
      <div className="ratio-date-cta">
        <DateCTA onClick={() => setOpenDateModal(true)} />
      </div>

      <div className="agent-analytics-chart mt-3 mt-lg-0">
        <Typography
          className="text-center mt-4"
          state="primary"
          variant="body0"
        >
          Agent To Aggregator Ratio
        </Typography>
        <Typography className="text-center" variant="caption0">
          Ratio of Enabled Agents to Aggregators on the TMS
        </Typography>
        <div
          style={{
            margin: "1.2rem 0 .5rem 0rem",
            textAlign: "center",
          }}
        >
          <MultiSelect
            placeholder={"All Regions"}
            value={selectedRegions}
            disabled={loading}
            isSearchable={false}
            clearable={false}
            handleChange={handleRegionsChange}
            isLoading={regions.loading}
            options={getRegionOptions()}
            onBlur={() => getAgentsData()}
            name="region-select"
          />
        </div>
        <div className="d-flex justify-content-center flex-wrap">
          {selectedRegions.length === regions.length ||
          !selectedRegions.length ? (
            <Typography variant="caption0">All Regions</Typography>
          ) : (
            selectedRegions.map((region, i) => (
              <Typography variant="caption0" key={i}>
                {region.label}
                {i === selectedRegions.length - 1 ? "." : ","} &nbsp;
              </Typography>
            ))
          )}
        </div>

        <div className="d-flex justify-content-center space-top-2">
          {loading ? (
            <div className={" text-center mtop-4"}>
              <Loader />
              <Typography state="grey" variant="body2">
                Loading data...
              </Typography>
            </div>
          ) : (
            <StatusIndicator
              percentage={aggregatorPercentage}
              color="blue"
              large
              childToRender={childToRender}
              showEdge={false}
              trackWidth="1.5"
            />
          )}
        </div>
      </div>
      {!loading && !data.isError && (
        <div className="mx-auto text-center mt-4">
          <Typography variant="body3">
            Total Aggregators:{" "}
            <span className="fw-bold">{totalAggregator}</span>
          </Typography>
          <Typography variant="body3">
            Total Agents: <span className="fw-bold">{totalAgent}</span>
          </Typography>
        </div>
      )}

      <DateFilterModal
        dateFrom={dates.dateFrom}
        dateTo={dates.dateTo}
        openDateModal={openDateModal}
        onClose={handleModalClose}
        handleFromChange={(val) => setRatioDates(val, "dateFrom")}
        handleToChange={(val) => setRatioDates(val, "dateTo")}
        onButtonClick={getAgentsData}
      />
    </div>
  );
};

export default AgentToAggregatorRatio;
